/**
 * Import the external scripts from our node_modules packages
 */
import 'es6-promise/auto'
import isEmpty from 'lodash/isEmpty'
import debounce from 'lodash/debounce'
import LazyLoad from 'vanilla-lazyload'
import objectFitImages from 'object-fit-images'
import quicklink from 'quicklink/dist/quicklink.umd.js'

/**
 * Import internal script from our theme
 */
import Accordion from './Accordion'
import Modal  from './Modal'
import Tooltip from './Tooltip'
import Navigation from './Navigation'
import ScrollAnimations from './misc/ScrollAnimations'
import FrontPage from './FrontPage'

class App {
    constructor() {
        this.reloaders = []
        this.init()
        this.initResize()
    }

    init() {
        new LazyLoad({ elements_selector: '.lazyload' })
        objectFitImages()
        quicklink.listen()

        new ScrollAnimations()
        new Accordion()
        new Navigation()
        new FrontPage()
        new Tooltip()
        new Modal()
    }

    initResize() {
        if (!isEmpty(this.reloaders)) {
            window.addEventListener('resize', debounce(() => {
                this.resize()
            }, 150), false)
        }
    }

    resize() {
        this.reloaders.forEach(element => {
            if (typeof element.resize === 'function') {
                element.resize()
            }
        })
    }
}

new App()